/* global google */
/**
 *
 *  Google Maps Provider
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 19/02/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React from "react";
import PropTypes from "prop-types";

// Utils
import { loadScript } from "../../utils";

const GOOGLE_MAPS_URL = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_MAPS_API_KEY}&v=3.exp&libraries=places&loading=async`;
const GOOGLE_MAPS = "google-maps-api";

const LOADING_STATE_NONE = "NONE";
const LOADING_STATE_BEGIN = "BEGIN";
const LOADING_STATE_LOADED = "LOADED";

export const contextTypes = {
  map: PropTypes.object,
};

export class GoogleMaps extends React.PureComponent {
  static propTypes = {};

  static childContextTypes = contextTypes;

  constructor(props) {
    super(props);

    this.state = {
      loadingState: LOADING_STATE_NONE,
      map: null,
    };

    this.isUnmounted = false;

    this.handleLoaded = this.handleLoaded.bind(this);
    this.initMap = this.initMap.bind(this); // Bind the initMap function
  }

  getChildContext() {
    return {
      map: this.state.map,
    };
  }

  initMap() {
    // Call handleLoaded when the Google Maps API is ready
    this.handleLoaded();
  }

  handleLoaded() {
    const { mapElement } = this.props;

    if (
      this.isUnmounted ||
      mapElement.current === null /* || this.state.map || node === null*/
    ) {
      return;
    }

    try {
      const map = new google.maps.Map(mapElement.current);
      this.setState({
        map,
        loadingState: LOADING_STATE_LOADED,
      });
      this.props.onLoaded && this.props.onLoaded(map);
    } catch {
      console.warn("Google Maps not loaded!");
    }
  }

  componentDidMount() {
    const { loadingState } = this.state;

    if (loadingState !== LOADING_STATE_NONE /* || !canUseDOM*/) {
      return;
    }

    this.setState({
      loadingState: LOADING_STATE_BEGIN,
    });

    // Define the callback function on the window object
    window.initMap = this.handleLoaded;

    // Load the script and set the callback to initMap
    loadScript(
      GOOGLE_MAPS_URL + `&callback=initMap`,
      GOOGLE_MAPS,
      this.handleLoaded
    );
  }

  componentWillUnmount() {
    this.isUnmounted = true;

    // Clean up the global callback
    delete window.initMap;
  }

  render() {
    return React.Children.only(this.props.children);
  }
}

export default GoogleMaps;
